import { App } from 'antd'
import type { MessageInstance } from 'antd/lib/message/interface'
import type { ModalStaticFunctions } from 'antd/lib/modal/confirm'
import type { NotificationInstance } from 'antd/lib/notification/interface'

let message: MessageInstance
let notification: NotificationInstance
let modal: Omit<ModalStaticFunctions, 'warn'>

export default () => {
  const staticFunction = App.useApp()
  message = staticFunction.message
  modal = staticFunction.modal
  notification = staticFunction.notification
  return null
}

export { message, modal, notification }
